import { serialize, Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';

export class SharedWorkspaceResultDto {
    id: number;
    key: string;
    name: string;
    categoryCode: string;
    config: string;

    @Type(() => UserNameDisplayResultDto)
    createdBy: UserNameDisplayResultDto;

    @Type(() => Date)
    createdDate: Date;

    isSystemType: boolean;
    allowEdit: boolean;
    allowDelete: boolean;
    allowExternalUsers: boolean;

    toConfigString(): any {
        return serialize(this.toJson());
    }

    toJson(): any {
        return {
            id: this.id,
            key: this.key,
            name: this.name,
            categoryCode: this.categoryCode,
            createdBy: this.createdBy,
            createdDate: this.createdDate,
            isSystemType: this.isSystemType,
            allowEdit: this.allowEdit,
            allowDelete: this.allowDelete,
            allowExternalUsers: this.allowExternalUsers
        };
    }
}
